module.exports = __webpack_public_path__ + "static/media/todo-list-min.c54dfdcd.png";